export default __webpack_public_path__ + "static/media/header-kucoin.c7cf85d1.svg";